// import React, { useEffect, useState } from "react";
// import {
//   Container,
//   Typography,
//   Grid,
//   Card,
//   CardContent,
//   Box,
//   Chip,
//   Button,
//   TextField,
//   InputAdornment,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   CircularProgress,
//   Fade,
//   Grow,
//   Divider,
// } from "@mui/material";

// import cleanJobDescription from "./cleanJobDescription";

// import SearchIcon from "@mui/icons-material/Search";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
// import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
// import { useNavigate } from "react-router-dom";
// import { colors } from "./theme";
// import logo from "./Averdex_logo.png";

// import { API_URL } from "./config";

// async function fetchJobOrdersSequentially(onJob) {
//   try {
//     const res = await fetch(`${API_URL}/joborder/uprotected`);
//     const jobs = await res.json();
//     if (Array.isArray(jobs)) {
//       for (const job of jobs) {
//         onJob(job);
//         await new Promise((r) => setTimeout(r, 100));
//       }
//     }
//   } catch {
//     return [];
//   }
// }

// export default function Homepage() {
//   const [jobOrders, setJobOrders] = useState([]);
//   const [search, setSearch] = useState("");
//   const [viewOpen, setViewOpen] = useState(false);
//   const [selectedJob, setSelectedJob] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();
  
//   useEffect(() => {
//     setJobOrders([]);
//     setLoading(true);
//     fetchJobOrdersSequentially((job) => {
//       setJobOrders((prev) => [...prev, job]);
//     }).finally(() => setLoading(false));
//   }, []);

//   const filteredJobOrders = jobOrders.filter((job) => {
//     if (!search.trim()) return true;
    
//     const searchTerm = search.toLowerCase().trim();
//     const cleanJobTitle = (job.job_title || '').replace(/^Job Title:\s*/i, '').trim().toLowerCase();
//     const searchInLocations = Array.isArray(job.locations) 
//       ? job.locations
//           .map(loc => (typeof loc === 'string' ? loc : loc.name || '').toLowerCase())
//           .join(' ')
//       : '';
    
//     return (
//       cleanJobTitle.includes(searchTerm) ||
//       searchInLocations.includes(searchTerm) ||
//       (job.company_name?.toLowerCase() || '').includes(searchTerm)
//     );
//   });

//   const handleView = (job) => {
//     setSelectedJob(job);
//     setViewOpen(true);
//   };

//   const newJobsCount = jobOrders.filter((j) => {
//     const created = new Date(j.created_at || j.created);
//     return Date.now() - created.getTime() < 7 * 24 * 60 * 60 * 1000;
//   }).length;

//   return (
//     <Box 
//       sx={{ 
//         minHeight: "100vh",
//         bgcolor: "#ffffff",
//         pb: 10,
//       }}
//     >
//       <Container maxWidth="lg" sx={{ pt: { xs: 8, md: 12 }, pb: 2 }}>
//         {/* Hero Section */}
//         <Fade in timeout={600}>
//           <Box sx={{ mb: 6, maxWidth: 900, mx: "auto", textAlign: "center" }}>
//             <Box
//               component="img"
//               src={logo}
//               alt="Averdex Logo"
//               sx={{
//                 width: { xs: 64, md: 80 },
//                 height: { xs: 64, md: 80 },
//                 mb: 4,
//                 mx: "auto",
//                 display: "block",
//               }}
//             />
            
//             <Typography
//               variant="h1"
//               sx={{
//                 fontSize: { xs: "2.25rem", sm: "3rem", md: "3.75rem" },
//                 fontWeight: 700,
//                 color: "#111827",
//                 mb: 2.5,
//                 lineHeight: 1.15,
//                 letterSpacing: "-0.025em",
//               }}
//             >
//               Welcome to Averdex Careers
//             </Typography>
            
//             <Typography
//               sx={{
//                 fontSize: { xs: "1rem", md: "1.125rem" },
//                 color: "#6b7280",
//                 mb: 5,
//                 lineHeight: 1.6,
//                 fontWeight: 400,
//                 maxWidth: 600,
//                 mx: "auto",
//               }}
//             >
//               Explore our open opportunities and join a team that's shaping the future of work.
//             </Typography>

//             <Button
//               variant="contained"
//               size="large"
//               onClick={() => navigate("/jobs")}
//               sx={{
//                 bgcolor: "#111827",
//                 color: "#ffffff",
//                 px: 4,
//                 py: 1.5,
//                 fontSize: "1rem",
//                 fontWeight: 600,
//                 borderRadius: 2,
//                 textTransform: "none",
//                 boxShadow: "none",
//                 mb: 6,
//                 transition: "all 0.2s ease",
//                 "&:hover": {
//                   bgcolor: "#1f2937",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                   transform: "translateY(-1px)",
//                 }
//               }}
//             >
//               View All Jobs
//             </Button>

//             {/* Stats Bar */}
//             {jobOrders.length > 0 && (
//               <Box 
//                 sx={{ 
//                   display: "flex", 
//                   gap: { xs: 3, sm: 6 },
//                   justifyContent: "center",
//                   flexWrap: "wrap",
//                   mb: 5,
//                 }}
//               >
//                 <Box sx={{ textAlign: "center" }}>
//                   <Typography sx={{ fontSize: { xs: "2rem", md: "2.5rem" }, fontWeight: 700, color: "#111827", lineHeight: 1 }}>
//                     {jobOrders.length}
//                   </Typography>
//                   <Typography sx={{ fontSize: "0.875rem", color: "#6b7280", fontWeight: 500, mt: 0.5 }}>
//                     Open positions
//                   </Typography>
//                 </Box>
//                 <Box sx={{ textAlign: "center" }}>
//                   <Typography sx={{ fontSize: { xs: "2rem", md: "2.5rem" }, fontWeight: 700, color: "#059669", lineHeight: 1 }}>
//                     {newJobsCount}
//                   </Typography>
//                   <Typography sx={{ fontSize: "0.875rem", color: "#6b7280", fontWeight: 500, mt: 0.5 }}>
//                     New this week
//                   </Typography>
//                 </Box>
//               </Box>
//             )}

//             {/* Search Bar */}
//             {jobOrders.length > 0 && (
//               <Box sx={{ maxWidth: 600, mx: "auto" }}>
//                 <TextField
//                   placeholder="Search by role, location, or keyword..."
//                   variant="outlined"
//                   fullWidth
//                   value={search}
//                   onChange={(e) => setSearch(e.target.value)}
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       bgcolor: "#ffffff",
//                       borderRadius: 2,
//                       fontSize: "0.9375rem",
//                       transition: "all 0.2s ease",
//                       "& fieldset": {
//                         borderColor: "#e5e7eb",
//                         borderWidth: 1.5,
//                       },
//                       "&:hover": {
//                         "& fieldset": {
//                           borderColor: "#d1d5db",
//                         },
//                       },
//                       "&.Mui-focused": {
//                         "& fieldset": {
//                           borderColor: "#111827",
//                           borderWidth: 2,
//                         },
//                       }
//                     },
//                     "& .MuiInputBase-input": {
//                       py: 1.75,
//                     }
//                   }}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <SearchIcon sx={{ color: "#9ca3af", fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Box>
//             )}
//           </Box>
//         </Fade>

//         {/* Loader */}
//         {loading && jobOrders.length === 0 && (
//           <Box display="flex" justifyContent="center" alignItems="center" minHeight={400}>
//             <CircularProgress size={40} sx={{ color: "#111827" }} />
//           </Box>
//         )}

//         {/* Job Cards */}
//         <Grid container spacing={3}>
//           {filteredJobOrders.length === 0 && !loading ? (
//             <Grid item xs={12}>
//               <Box sx={{ textAlign: "center", py: 10 }}>
//                 <Typography sx={{ fontSize: "1.125rem", color: "#6b7280" }}>
//                   No positions available at the moment.
//                 </Typography>
//                 <Typography sx={{ fontSize: "0.875rem", color: "#9ca3af", mt: 1 }}>
//                   Check back soon for new opportunities.
//                 </Typography>
//               </Box>
//             </Grid>
//           ) : (
//             filteredJobOrders.map((job, index) => {
//               const isNew = (() => {
//                 const created = new Date(job.created_at || job.created);
//                 return Date.now() - created.getTime() < 7 * 24 * 60 * 60 * 1000;
//               })();

//               return (
//                 <Grid item xs={12} sm={6} lg={4} key={job.id}>
//                   <Grow in timeout={400 + index * 50}>
//                     <Card
//                       sx={{
//                         height: "100%",
//                         display: "flex",
//                         flexDirection: "column",
//                         border: "1px solid #f0f0f0",
//                         borderRadius: 3,
//                         boxShadow: "none",
//                         cursor: "pointer",
//                         transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
//                         "&:hover": {
//                           transform: "translateY(-4px)",
//                           boxShadow: "0 12px 24px -10px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.04)",
//                           borderColor: "#e5e7eb",
//                         },
//                       }}
//                       onClick={() => navigate(`/apply/${job.id}`)}
//                     >
//                       <CardContent sx={{ p: 4, flexGrow: 1, display: "flex", flexDirection: "column" }}>
//                         <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 3 }}>
//                           <Typography
//                             variant="h6"
//                             sx={{
//                               fontSize: "1.25rem",
//                               fontWeight: 600,
//                               color: "#111827",
//                               lineHeight: 1.3,
//                               pr: 2,
//                             }}
//                           >
//                             {job.job_title}
//                           </Typography>
//                           {isNew && (
//                             <Chip
//                               label="New"
//                               size="small"
//                               sx={{
//                                 bgcolor: "#dcfce7",
//                                 color: "#166534",
//                                 fontWeight: 600,
//                                 fontSize: "0.75rem",
//                                 height: 24,
//                                 borderRadius: 1.5,
//                                 "& .MuiChip-label": {
//                                   px: 1.5,
//                                 }
//                               }}
//                             />
//                           )}
//                         </Box>

//                         <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 3, flexGrow: 1 }}>
//                           <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                             <BusinessCenterOutlinedIcon sx={{ fontSize: 18, color: "#9ca3af" }} />
//                             <Typography sx={{ fontSize: "0.875rem", color: "#6b7280" }}>
//                               {job.department || "Various"}
//                             </Typography>
//                           </Box>
//                           <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                             <LocationOnOutlinedIcon sx={{ fontSize: 18, color: "#9ca3af" }} />
//                             <Typography sx={{ fontSize: "0.875rem", color: "#6b7280" }}>
//                               {Array.isArray(job.locations) && job.locations.length > 0
//                                 ? job.locations
//                                     .map((loc) => typeof loc === "string" ? loc : loc.name)
//                                     .filter(Boolean)
//                                     .join(", ")
//                                 : "Remote"}
//                             </Typography>
//                           </Box>
//                         </Box>

//                         <Divider sx={{ mb: 2.5 }} />

//                         <Box sx={{ display: "flex", gap: 1.5 }}>
//                           <Button
//                             size="small"
//                             variant="outlined"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               handleView(job);
//                             }}
//                             sx={{
//                               textTransform: "none",
//                               fontWeight: 500,
//                               fontSize: "0.875rem",
//                               borderColor: "#e5e7eb",
//                               color: "#6b7280",
//                               px: 2.5,
//                               py: 1,
//                               borderRadius: 2,
//                               "&:hover": {
//                                 borderColor: "#d1d5db",
//                                 bgcolor: "#f9fafb",
//                               }
//                             }}
//                           >
//                             View details
//                           </Button>
//                           <Button
//                             size="small"
//                             variant="contained"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               navigate(`/apply/${job.id}`);
//                             }}
//                             sx={{
//                               textTransform: "none",
//                               fontWeight: 600,
//                               fontSize: "0.875rem",
//                               bgcolor: "#111827",
//                               px: 2.5,
//                               py: 1,
//                               borderRadius: 2,
//                               boxShadow: "none",
//                               "&:hover": {
//                                 bgcolor: "#1f2937",
//                                 boxShadow: "none",
//                               }
//                             }}
//                           >
//                             Apply now
//                           </Button>
//                         </Box>
//                       </CardContent>
//                     </Card>
//                   </Grow>
//                 </Grid>
//               );
//             })
//           )}
//         </Grid>

//         {/* View Modal */}
//         <Dialog
//           open={viewOpen}
//           onClose={() => setViewOpen(false)}
//           maxWidth="md"
//           fullWidth
//           PaperProps={{
//             sx: {
//               borderRadius: 3,
//               boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)",
//             }
//           }}
//         >
//           <DialogTitle sx={{ fontWeight: 600, fontSize: "1.5rem", pb: 2, pt: 4, px: 4 }}>
//             {selectedJob?.job_title}
//           </DialogTitle>
//           <DialogContent sx={{ px: 4, pb: 3 }}>
//             {selectedJob && (
//               <Box>
//                 <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 3 }}>
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <BusinessCenterOutlinedIcon sx={{ fontSize: 18, color: "#9ca3af" }} />
//                     <Typography sx={{ fontSize: "0.875rem", color: "#6b7280" }}>
//                       {selectedJob.department}
//                     </Typography>
//                   </Box>
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <LocationOnOutlinedIcon sx={{ fontSize: 18, color: "#9ca3af" }} />
//                     <Typography sx={{ fontSize: "0.875rem", color: "#6b7280" }}>
//                       {Array.isArray(selectedJob.locations) && selectedJob.locations.length > 0
//                         ? selectedJob.locations
//                             .map((loc) => typeof loc === "string" ? loc : loc.name)
//                             .filter(Boolean)
//                             .join("; ")
//                         : "-"}
//                     </Typography>
//                   </Box>
//                 </Box>

//                 <Divider sx={{ my: 3 }} />

//                 <Box sx={{ mb: 3, "& p": { color: "#374151", lineHeight: 1.7 } }}>
//                   <div
//                     dangerouslySetInnerHTML={{
//                       __html: cleanJobDescription(selectedJob.job_description || ""),
//                     }}
//                   />
//                 </Box>

//                 <Box sx={{ display: "flex", alignItems: "center", mb: 2, flexWrap: "wrap", gap: 1 }}>
//                   <Typography sx={{ fontWeight: 600, fontSize: "0.875rem", color: "#111827" }}>Type:</Typography>
//                   {selectedJob.job_types && selectedJob.job_types.length > 0 ? (
//                     selectedJob.job_types.map((type, idx) => (
//                       <Chip
//                         key={type.id || type.name || idx}
//                         label={type.name}
//                         size="small"
//                         sx={{
//                           bgcolor: "#f3f4f6",
//                           color: "#374151",
//                           fontSize: "0.75rem",
//                           fontWeight: 500,
//                         }}
//                       />
//                     ))
//                   ) : (
//                     <Chip label="-" size="small" sx={{ bgcolor: "#f3f4f6", color: "#9ca3af" }} />
//                   )}
//                 </Box>

//                 <Typography sx={{ mb: 1.5, fontSize: "0.875rem", color: "#6b7280" }}>
//                   <strong style={{ color: "#111827" }}>Status:</strong> {selectedJob.status}
//                 </Typography>
//                 <Typography sx={{ fontSize: "0.875rem", color: "#6b7280" }}>
//                   <strong style={{ color: "#111827" }}>Apply before:</strong>{" "}
//                   {selectedJob.end_date ? new Date(selectedJob.end_date).toLocaleDateString() : "-"}
//                 </Typography>
//               </Box>
//             )}
//           </DialogContent>
//           <DialogActions sx={{ px: 4, pb: 4, pt: 2 }}>
//             <Button 
//               onClick={() => setViewOpen(false)}
//               sx={{
//                 textTransform: "none",
//                 color: "#6b7280",
//                 fontWeight: 500,
//                 "&:hover": {
//                   bgcolor: "#f9fafb",
//                 }
//               }}
//             >
//               Close
//             </Button>
//             <Button
//               variant="contained"
//               onClick={() => {
//                 setViewOpen(false);
//                 navigate(`/apply/${selectedJob?.id}`);
//               }}
//               sx={{
//                 textTransform: "none",
//                 fontWeight: 600,
//                 bgcolor: "#111827",
//                 px: 3,
//                 boxShadow: "none",
//                 "&:hover": {
//                   bgcolor: "#1f2937",
//                   boxShadow: "none",
//                 }
//               }}
//             >
//               Apply now
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </Container>
//     </Box>
//   );
// }


import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  Chip,
  Button,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Divider,
  Fade,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import cleanJobDescription from "./cleanJobDescription";
import SearchIcon from "@mui/icons-material/Search";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import { useNavigate } from "react-router-dom";
import logo from "./Averdex_logo.png";
import { API_URL } from "./config";

async function fetchJobOrdersSequentially(onJob) {
  try {
    const res = await fetch(`${API_URL}/joborder/uprotected`);
    const jobs = await res.json();

    if (Array.isArray(jobs)) {
      for (const job of jobs) {
        onJob(job);
        await new Promise((r) => setTimeout(r, 70));
      }
    }
  } catch {
    return [];
  }
}

function SectionEyebrow({ children, color }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        color,
        fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: "10.5px",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        fontWeight: 500,
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 2,
          borderRadius: 2,
          bgcolor: "currentColor",
          flexShrink: 0,
        }}
      />
      {children}
    </Box>
  );
}

function getLocations(job) {
  return Array.isArray(job.locations) && job.locations.length > 0
    ? job.locations
        .map((loc) => (typeof loc === "string" ? loc : loc?.name))
        .filter(Boolean)
        .join(", ")
    : "Remote / Flexible";
}

function formatDeadline(value) {
  if (!value) return "-";
  return new Date(value).toLocaleDateString();
}

function isNewJob(job) {
  const created = new Date(job.created_at || job.created);
  return Date.now() - created.getTime() < 7 * 24 * 60 * 60 * 1000;
}

function PaperlessHero({
  logo,
  accent,
  text,
  mid,
  muted,
  border,
  openPositions,
  newJobsCount,
  search,
  setSearch,
  jobOrders,
  navigate,
  dark,
}) {
  return (
    <Box sx={{ mb: 6 }}>
      <Box
        sx={{
          overflow: "hidden",
          borderRadius: "28px",
          border: `1px solid ${border}`,
          background: dark
            ? `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(7,8,15,0.96) 45%, rgba(7,8,15,0.98) 100%)`
            : `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(255,255,255,0.98) 42%, rgba(248,248,251,0.98) 100%)`,
          boxShadow: dark
            ? "0 32px 80px rgba(0,0,0,0.45)"
            : "0 32px 80px rgba(15,15,26,0.08)",
        }}
      >
        <Grid container>
          <Grid item xs={12} md={7.5}>
            <Box sx={{ p: { xs: 3, sm: 4, md: 5 } }}>
              <SectionEyebrow color={accent}>AjiraHQ · Careers</SectionEyebrow>

              <Box
                sx={{
                  mt: 3,
                  width: 60,
                  height: 60,
                  borderRadius: "18px",
                  border: `1px solid ${alpha(accent, 0.22)}`,
                  background: dark
                    ? `linear-gradient(135deg, ${alpha(accent, 0.16)}, rgba(13,18,32,0.88))`
                    : `linear-gradient(135deg, ${alpha(accent, 0.10)}, rgba(255,255,255,0.96))`,
                  display: "grid",
                  placeItems: "center",
                  boxShadow: dark
                    ? "0 10px 24px rgba(0,0,0,0.22)"
                    : "0 10px 24px rgba(15,15,26,0.06)",
                }}
              >
                <Box
                  component="img"
                  src={logo}
                  alt="AjiraHQ"
                  sx={{
                    width: 32,
                    height: 32,
                    objectFit: "contain",
                  }}
                />
              </Box>

              <Typography
                sx={{
                  mt: 3,
                  fontSize: { xs: "2.4rem", md: "3.7rem" },
                  fontWeight: 800,
                  color: text,
                  mb: 2,
                  lineHeight: 1.05,
                  letterSpacing: "-0.03em",
                  maxWidth: 740,
                }}
              >
                Find your next opportunity with clarity.
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: "1rem", md: "1.08rem" },
                  color: mid,
                  mb: 4,
                  lineHeight: 1.8,
                  maxWidth: 620,
                }}
              >
                Explore current openings, review role details, and apply through a
                clean, structured hiring experience powered by AjiraHQ.
              </Typography>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 4 }}>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => navigate("/jobs")}
                  sx={{
                    background: accent,
                    color: "#fff",
                    px: 3.4,
                    py: 1.35,
                    borderRadius: "12px",
                    fontWeight: 700,
                    textTransform: "none",
                    boxShadow: `0 16px 40px ${alpha(accent, 0.24)}`,
                    "&:hover": {
                      background: accent,
                      filter: "brightness(1.08)",
                    },
                  }}
                >
                  View All Jobs →
                </Button>

                <Button
                  variant="outlined"
                  size="large"
                  onClick={() =>
                    document
                      .getElementById("homepage-search")
                      ?.scrollIntoView({ behavior: "smooth", block: "center" })
                  }
                  sx={{
                    borderColor: alpha(accent, 0.26),
                    color: accent,
                    px: 3.2,
                    py: 1.3,
                    borderRadius: "12px",
                    fontWeight: 700,
                    textTransform: "none",
                    "&:hover": {
                      borderColor: accent,
                      background: alpha(accent, 0.06),
                    },
                  }}
                >
                  Search roles
                </Button>
              </Box>

              {jobOrders.length > 0 && (
                <Box
                  sx={{
                    mt: 1,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 4,
                    borderTop: `1px solid ${border}`,
                    pt: 3.5,
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: { xs: "2rem", md: "2.45rem" },
                        fontWeight: 800,
                        color: text,
                        lineHeight: 1,
                      }}
                    >
                      {openPositions}
                    </Typography>
                    <Typography
                      sx={{
                        mt: 0.5,
                        fontSize: "11px",
                        letterSpacing: "0.16em",
                        textTransform: "uppercase",
                        color: muted,
                        fontFamily:
                          '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
                      }}
                    >
                      Open positions
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        fontSize: { xs: "2rem", md: "2.45rem" },
                        fontWeight: 800,
                        color: accent,
                        lineHeight: 1,
                      }}
                    >
                      {newJobsCount}
                    </Typography>
                    <Typography
                      sx={{
                        mt: 0.5,
                        fontSize: "11px",
                        letterSpacing: "0.16em",
                        textTransform: "uppercase",
                        color: muted,
                        fontFamily:
                          '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
                      }}
                    >
                      New this week
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4.5}>
            <Box
              sx={{
                height: "100%",
                p: { xs: 3, sm: 4, md: 5 },
                borderTop: { xs: `1px solid ${border}`, md: "none" },
                borderLeft: { xs: "none", md: `1px solid ${border}` },
                background: dark
                  ? "rgba(8,12,24,0.45)"
                  : "rgba(255,255,255,0.55)",
              }}
            >
              <Box
                sx={{
                  p: 3,
                  borderRadius: "22px",
                  border: `1px solid ${border}`,
                  background: dark
                    ? "rgba(13,18,32,0.9)"
                    : "rgba(255,255,255,0.88)",
                }}
              >
                <SectionEyebrow color={accent}>Quick search</SectionEyebrow>

                <Typography
                  sx={{
                    mt: 2,
                    color: text,
                    fontWeight: 800,
                    fontSize: "1.55rem",
                    lineHeight: 1.15,
                    letterSpacing: "-0.02em",
                  }}
                >
                  Search current openings
                </Typography>

                <Typography
                  sx={{
                    mt: 1,
                    color: mid,
                    fontSize: "14px",
                    lineHeight: 1.75,
                    mb: 2.5,
                  }}
                >
                  Filter roles by title, department, or location.
                </Typography>

                <TextField
                  id="homepage-search"
                  placeholder="Search by role, location, or keyword..."
                  variant="outlined"
                  fullWidth
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: dark ? "rgba(8,12,24,0.7)" : "#ffffff",
                      borderRadius: "14px",
                      fontSize: "0.95rem",
                      transition: "all 0.2s ease",
                      "& fieldset": {
                        borderColor: border,
                      },
                      "&:hover fieldset": {
                        borderColor: border,
                      },
                      "&.Mui-focused": {
                        boxShadow: `0 0 0 4px ${alpha(accent, 0.12)}`,
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: accent,
                      },
                    },
                    "& .MuiInputBase-input": {
                      py: 1.55,
                      color: text,
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: muted, fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                />

                <Box
                  sx={{
                    mt: 2.5,
                    display: "grid",
                    gap: 1.35,
                  }}
                >
                  {[
                    "Clean application experience",
                    "Fast role discovery",
                    "Dark and light mode ready",
                  ].map((item) => (
                    <Box
                      key={item}
                      sx={{
                        display: "flex",
                        gap: 1.25,
                        alignItems: "flex-start",
                      }}
                    >
                      <Box
                        sx={{
                          mt: 0.65,
                          width: 18,
                          height: 18,
                          borderRadius: 999,
                          display: "grid",
                          placeItems: "center",
                          bgcolor: alpha(accent, 0.14),
                          color: accent,
                          fontSize: "11px",
                          fontWeight: 800,
                          flexShrink: 0,
                        }}
                      >
                        ✓
                      </Box>
                      <Typography
                        sx={{
                          color: mid,
                          fontSize: "14px",
                          lineHeight: 1.75,
                          fontWeight: 500,
                        }}
                      >
                        {item}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default function Homepage() {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const navigate = useNavigate();

  const accent = dark ? "#fb923c" : "#f97316";
  const pageBg = dark ? "#07080f" : "#ffffff";
  const cardBg = dark ? "#0d1220" : "#ffffff";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";
  const borderStrong = dark ? "rgba(99, 179, 237, 0.22)" : "#d4d4e4";

  const [jobOrders, setJobOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setJobOrders([]);
    setLoading(true);
    fetchJobOrdersSequentially((job) => {
      setJobOrders((prev) => [...prev, job]);
    }).finally(() => setLoading(false));
  }, []);

  const filteredJobOrders = useMemo(() => {
    return jobOrders.filter((job) => {
      if (!search.trim()) return true;

      const searchTerm = search.toLowerCase().trim();
      const cleanJobTitle = (job.job_title || "")
        .replace(/^Job Title:\s*/i, "")
        .trim()
        .toLowerCase();

      const searchInLocations = Array.isArray(job.locations)
        ? job.locations
            .map((loc) =>
              (typeof loc === "string" ? loc : loc?.name || "").toLowerCase()
            )
            .join(" ")
        : "";

      return (
        cleanJobTitle.includes(searchTerm) ||
        searchInLocations.includes(searchTerm) ||
        (job.company_name?.toLowerCase() || "").includes(searchTerm) ||
        (job.department?.toLowerCase() || "").includes(searchTerm)
      );
    });
  }, [jobOrders, search]);

  const handleView = (job) => {
    setSelectedJob(job);
    setViewOpen(true);
  };

  const openPositions = jobOrders.length;
  const newJobsCount = jobOrders.filter(isNewJob).length;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: pageBg,
        pt: { xs: 11, md: 13 },
        pb: 10,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          background: dark
            ? `radial-gradient(circle at 15% 12%, ${alpha(accent, 0.12)} 0%, transparent 26%),
               radial-gradient(circle at 85% 18%, rgba(56,189,248,0.10) 0%, transparent 24%)`
            : `radial-gradient(circle at 15% 12%, ${alpha(accent, 0.08)} 0%, transparent 24%),
               radial-gradient(circle at 85% 18%, rgba(79,70,229,0.06) 0%, transparent 22%)`,
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Fade in timeout={600}>
          <Box>
            <PaperlessHero
              logo={logo}
              accent={accent}
              text={text}
              mid={mid}
              muted={muted}
              border={border}
              openPositions={openPositions}
              newJobsCount={newJobsCount}
              search={search}
              setSearch={setSearch}
              jobOrders={jobOrders}
              navigate={navigate}
              dark={dark}
            />
          </Box>
        </Fade>

        {loading && jobOrders.length === 0 ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight={320}
          >
            <CircularProgress sx={{ color: accent }} />
          </Box>
        ) : (
          <Grid container spacing={3}>
            {filteredJobOrders.length === 0 ? (
              <Grid item xs={12}>
                <Box
                  sx={{
                    textAlign: "center",
                    py: 10,
                    borderRadius: "24px",
                    border: `1px solid ${border}`,
                    background: cardBg,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "1.125rem",
                      color: text,
                      fontWeight: 700,
                    }}
                  >
                    No matching roles right now.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.9375rem",
                      color: mid,
                      mt: 1,
                    }}
                  >
                    Try a different keyword or check back soon for new openings.
                  </Typography>
                </Box>
              </Grid>
            ) : (
              filteredJobOrders.map((job) => {
                const isNew = isNewJob(job);

                return (
                  <Grid item xs={12} sm={6} lg={4} key={job.id}>
                    <Card
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        border: `1px solid ${border}`,
                        borderRadius: "24px",
                        background: cardBg,
                        boxShadow: dark
                          ? "0 20px 50px rgba(0,0,0,0.28)"
                          : "0 20px 50px rgba(15,15,26,0.05)",
                        transition:
                          "transform .25s ease, box-shadow .25s ease, border-color .25s ease",
                        cursor: "pointer",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          borderColor: accent,
                          boxShadow: dark
                            ? `0 28px 60px rgba(0,0,0,0.35), 0 0 0 1px ${alpha(
                                accent,
                                0.18
                              )}`
                            : `0 28px 60px rgba(15,15,26,0.08), 0 0 0 1px ${alpha(
                                accent,
                                0.14
                              )}`,
                        },
                      }}
                      onClick={() => navigate(`/apply/${job.id}`)}
                    >
                      <CardContent
                        sx={{
                          p: 3,
                          flexGrow: 1,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            gap: 1.5,
                            mb: 2.5,
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "1.2rem",
                              fontWeight: 800,
                              color: text,
                              lineHeight: 1.25,
                              letterSpacing: "-0.02em",
                            }}
                          >
                            {job.job_title}
                          </Typography>

                          {isNew && (
                            <Chip
                              label="New"
                              size="small"
                              sx={{
                                borderRadius: 999,
                                fontWeight: 700,
                                fontSize: "0.72rem",
                                background: alpha(accent, dark ? 0.14 : 0.08),
                                color: accent,
                                border: `1px solid ${alpha(accent, 0.24)}`,
                              }}
                            />
                          )}
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.35,
                            mb: 2.75,
                            flexGrow: 1,
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <BusinessCenterOutlinedIcon
                              sx={{ fontSize: 18, color: muted }}
                            />
                            <Typography
                              sx={{
                                fontSize: "0.92rem",
                                color: mid,
                                lineHeight: 1.7,
                              }}
                            >
                              {job.department || "General hiring"}
                            </Typography>
                          </Box>

                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <LocationOnOutlinedIcon
                              sx={{ fontSize: 18, color: muted }}
                            />
                            <Typography
                              sx={{
                                fontSize: "0.92rem",
                                color: mid,
                                lineHeight: 1.7,
                              }}
                            >
                              {getLocations(job)}
                            </Typography>
                          </Box>

                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Typography
                              sx={{
                                minWidth: 86,
                                fontSize: "11px",
                                fontWeight: 500,
                                letterSpacing: "0.16em",
                                textTransform: "uppercase",
                                color: muted,
                                fontFamily:
                                  '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
                              }}
                            >
                              Apply by
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "0.9rem",
                                color: text,
                                fontWeight: 600,
                              }}
                            >
                              {formatDeadline(job.end_date)}
                            </Typography>
                          </Box>
                        </Box>

                        <Divider sx={{ mb: 2.5, borderColor: border }} />

                        <Box sx={{ display: "flex", gap: 1.25, flexWrap: "wrap" }}>
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleView(job);
                            }}
                            sx={{
                              textTransform: "none",
                              fontWeight: 600,
                              fontSize: "0.875rem",
                              borderRadius: "12px",
                              px: 2.2,
                              py: 0.9,
                              borderColor: borderStrong,
                              color: mid,
                              "&:hover": {
                                borderColor: accent,
                                color: accent,
                                background: "transparent",
                              },
                            }}
                          >
                            View details
                          </Button>

                          <Button
                            size="small"
                            variant="contained"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(`/apply/${job.id}`);
                            }}
                            sx={{
                              textTransform: "none",
                              fontWeight: 700,
                              fontSize: "0.875rem",
                              borderRadius: "12px",
                              px: 2.4,
                              py: 0.9,
                              background: accent,
                              color: "#fff",
                              boxShadow: `0 14px 34px ${alpha(accent, 0.22)}`,
                              "&:hover": {
                                background: accent,
                                filter: "brightness(1.08)",
                              },
                            }}
                          >
                            Apply now
                          </Button>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })
            )}
          </Grid>
        )}

        <Dialog
          open={viewOpen}
          onClose={() => setViewOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "24px",
              border: `1px solid ${border}`,
              background: cardBg,
              boxShadow: dark
                ? "0 20px 50px rgba(0,0,0,0.28)"
                : "0 20px 50px rgba(15,15,26,0.05)",
            },
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 800,
              fontSize: "1.6rem",
              color: text,
              pt: 4,
              px: 4,
              pb: 2,
              letterSpacing: "-0.02em",
            }}
          >
            {selectedJob?.job_title}
          </DialogTitle>

          <DialogContent sx={{ px: 4, pb: 3 }}>
            {selectedJob && (
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.25,
                    mb: 3,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <BusinessCenterOutlinedIcon sx={{ fontSize: 18, color: muted }} />
                    <Typography sx={{ fontSize: "0.92rem", color: mid }}>
                      {selectedJob.department || "General hiring"}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <LocationOnOutlinedIcon sx={{ fontSize: 18, color: muted }} />
                    <Typography sx={{ fontSize: "0.92rem", color: mid }}>
                      {getLocations(selectedJob)}
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ my: 3, borderColor: border }} />

                <Box
                  sx={{
                    mb: 3,
                    "& p": {
                      color: mid,
                      lineHeight: 1.85,
                      fontSize: "15px",
                    },
                    "& h1, & h2, & h3, & h4": {
                      color: text,
                      fontWeight: 800,
                      letterSpacing: "-0.02em",
                    },
                    "& ul, & ol": {
                      color: mid,
                      pl: 2.5,
                    },
                    "& li": {
                      mb: 1,
                      lineHeight: 1.75,
                    },
                    "& strong": {
                      color: text,
                    },
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: cleanJobDescription(selectedJob.job_description || ""),
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    flexWrap: "wrap",
                    gap: 1,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "0.88rem",
                      color: text,
                    }}
                  >
                    Type:
                  </Typography>

                  {selectedJob.job_types && selectedJob.job_types.length > 0 ? (
                    selectedJob.job_types.map((type, idx) => (
                      <Chip
                        key={type.id || type.name || idx}
                        label={type.name}
                        size="small"
                        sx={{
                          borderRadius: 999,
                          background: dark
                            ? "rgba(255,255,255,0.04)"
                            : "rgba(15,15,26,0.03)",
                          color: mid,
                          border: `1px solid ${border}`,
                          fontWeight: 600,
                        }}
                      />
                    ))
                  ) : (
                    <Chip
                      label="-"
                      size="small"
                      sx={{
                        borderRadius: 999,
                        background: dark
                          ? "rgba(255,255,255,0.04)"
                          : "rgba(15,15,26,0.03)",
                        color: mid,
                        border: `1px solid ${border}`,
                      }}
                    />
                  )}
                </Box>

                <Typography sx={{ mb: 1.25, fontSize: "0.92rem", color: mid }}>
                  <strong style={{ color: text }}>Status:</strong>{" "}
                  {selectedJob.status || "-"}
                </Typography>

                <Typography sx={{ fontSize: "0.92rem", color: mid }}>
                  <strong style={{ color: text }}>Apply before:</strong>{" "}
                  {formatDeadline(selectedJob.end_date)}
                </Typography>
              </Box>
            )}
          </DialogContent>

          <DialogActions sx={{ px: 4, pb: 4, pt: 2 }}>
            <Button
              onClick={() => setViewOpen(false)}
              sx={{
                textTransform: "none",
                color: mid,
                fontWeight: 600,
                "&:hover": {
                  background: dark ? "rgba(255,255,255,0.04)" : "#f9fafb",
                },
              }}
            >
              Close
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                setViewOpen(false);
                navigate(`/apply/${selectedJob?.id}`);
              }}
              sx={{
                textTransform: "none",
                fontWeight: 700,
                borderRadius: "12px",
                background: accent,
                px: 3,
                boxShadow: `0 14px 34px ${alpha(accent, 0.22)}`,
                "&:hover": {
                  background: accent,
                  filter: "brightness(1.08)",
                },
              }}
            >
              Apply now
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Box>
  );
}